define('services/common/handleMainPageDia-service',['app', 'mainCons'], function (app, mainCons) {
    app.factory('remindToUpdateUserInfo', ['$q', '$state', '$rootScope', 'ngDialog', 'UserInfo', '$timeout', 'OpenUp', 'auiDialog', '$filter', function ($q, $state, $rootScope, ngDialog, UserInfo, $timeout, OpenUp, auiDialog, $filter) {

        function remindToUpdateUserInfo(latestUserInfo, callback) {
            var defer = $q.defer();
            // 只对企业用户做检查
            // 当用户的资料处于更新带审核状态时，即便超过6个月，也不提示  主帐号
            if (!AUI.HDGWCall.getUserInfoValue('teamid') && latestUserInfo && latestUserInfo.verifyRealState == 2 && latestUserInfo.updateRealState != 1 && latestUserInfo.isChangeRealName != 1) {
                var lastTime = latestUserInfo.lastContactMaintainTime ? AUI.DateUtil.DateStr2UtcMills(latestUserInfo.lastContactMaintainTime) : 0;
                if (!lastTime || lastTime + sysUrlCfg.verifyUserCfg.lastTime <= new Date().getTime()) {
                    UserInfo.userAcctInfoList().then(function () {
                        ngDialog.open({
                            template: 'pages/common/dislog.update.userinfo.html',
                            className: '',
                            closeByEscape: false,
                            closeByDocument: false,
                            overlay: false,
                            controller: ['$scope', function ($scope) {
                                var dev = $scope.dev = UserInfo.get();
                                var oldDev = angular.copy(UserInfo.get());
                                var Model = $scope.Model = {
                                    errorPhone: [],
                                };
                                dev.resetVer = false;
                                $scope.isContactNameValid = true;
                                $scope.isContactEmailValid = true;
                                $scope.isContactPhoneValid = true;
                                $scope.isShowPhoneVer = true;
                                $scope.isShowEmailVer = true;
                                $scope.isContactIdCardValid = true;
                                $scope.contactMobilePhoneVerification = systemParaConf.contactMobilePhoneVerification
                                dev.verCode = '';
                                dev.verEmialCode = '';
                                $scope.contactNameChange = contactNameChange;
                                $scope.contactEmailChange = contactEmailChange;
                                $scope.contactPhoneChange = contactPhoneChange;
                                $scope.latestUserInfo = latestUserInfo;
                                $scope.failed_times = 0;
                                dev.verifiedPhoneSuccess = false;
                                dev.verifiedEmailSuccess = false;
                                $scope.updateUserInfo = updateUserInfo;
                                $scope.contactIdCardChange = contactIdCardChange;

                                function contactIdCardChange() {
                                    $scope.isContactIdCardValid = AUI.BaseJSUtil.isIdCard($.trim(dev.contactIdCard)) && !!dev.contactIdCard;
                                }

                                function contactNameChange() {
                                    $scope.isContactNameValid = AUI.BaseJSUtil.lengthCheck($.trim(dev.contactName), 64, 1);
                                }

                                function contactEmailChange() {
                                    $scope.isContactEmailValid = AUI.BaseJSUtil.lengthCheck(dev.contactEmail, 128, 1) && AUI.BaseJSUtil.isEmail(dev.contactEmail);
                                    if ($scope.isContactEmailValid) {
                                        dev.verEmailCode = "";
                                        $scope.isShowEmailVer = true;
                                        $scope.verEmailSuccess = false;
                                    } else {
                                        $scope.isShowEmailVer = false;
                                    }
                                }

                                function contactPhoneChange() {
                                    $scope.isContactPhoneValid = AUI.BaseJSUtil.lengthCheck(dev.contactPhone, 64, 1) && AUI.BaseJSUtil.isMobile(dev.contactPhone);
                                    if ($scope.isContactPhoneValid) {
                                        dev.verCode = "";
                                        $scope.isShowPhoneVer = true;
                                        $scope.verPhoneSuccess = false;
                                    } else {
                                        $scope.isShowPhoneVer = false;
                                    }
                                }

                                $scope.checkErrorPhone = function () {
                                    return AUI.BaseJSUtil.contains(Model.errorPhone, dev.contactPhone);
                                }

                                function updateUserInfo() {
                                    var defer = $q.defer();
                                    if (dev.userType == 2) {
                                        contactIdCardChange();
                                    }
                                    if ($scope.checkErrorPhone() || !$scope.isContactPhoneValid
                                        || !$scope.isContactNameValid || !$scope.isContactEmailValid
                                        || !$scope.isContactIdCardValid || ($scope.isShowEmailVer && !dev.verifiedEmailSuccess)
                                        || ($scope.isShowPhoneVer && !dev.verifiedPhoneSuccess)) {
                                        defer.reject();
                                        return defer.promise;
                                    }
                                    var param = {
                                        contactName: dev.contactName,
                                        contactEmail: dev.contactEmail,
                                        contactPhone: "0086" + dev.contactPhone,
                                        smsAuthCode: dev.verCode,
                                        emailAuthCode: dev.verEmailCode,
                                        contactIdCard: dev.contactIdCard
                                    };
                                    OpenUp.confirmContactInfo({req: param}, true).then(function (data) {
                                       if (data && data.userID) {
                                            defer.reject();
                                            auiDialog.success(sysParamCfg.successInfo.verify_user_success, function () {
                                                ngDialog.close();
                                                location.reload();
                                            });
                                        } else {
                                            defer.reject();
                                        }
                                    }).catch(function (data) {
                                        defer.reject();
                                        $scope.failed_times++;
                                        dev.resetVer = true;
                                        var errorInfo = '';
                                        errorInfo = $filter('auiErrorCode')(data.NSP_STATUS, data.serviceName);
                                        if ($scope.failed_times >= sysUrlCfg.verifyUserCfg.maxTryTime) {
                                            if (AUI.BaseJSUtil.contains([70009007, 70009004, 70009005], data.NSP_STATUS)) {//对70009007 70009004 70009005 特殊处理 加个13凑下数
                                                errorInfo = $filter('auiErrorCode')(data.NSP_STATUS + '13', data.serviceName);
                                            } else {
                                                errorInfo += "<br/>您失败次数过多，请下次登录时更新联系信息。";
                                            }
                                            auiDialog.fail("更新失败", errorInfo, function () {
                                                if ((callback) && (typeof callback == 'function')) {
                                                    callback();
                                                }
                                                ngDialog.close();
                                            });
                                        } else {
                                            if (data && data.NSP_STATUS == 70009006) {
                                                Model.errorPhone.push(dev.contactPhone);
                                            } else {
                                                auiDialog.fail("更新失败", errorInfo);
                                            }
                                        }
                                    });
                                    return defer.promise;
                                }


                            }]
                        });
                        defer.resolve(false);
                    });
                } else {
                    if ((callback) && (typeof callback == 'function')) {
                        callback();
                    }
                    defer.resolve(true);
                }
            } else {
                if ((callback) && (typeof callback == 'function')) {
                    callback();
                }
                defer.resolve(true);
            }
            return defer.promise;
        }

        //联盟APP渠道推广
        function appPromotionService() {

            function checkDay() {
                var appPromotion_value = localStorage.getItem(currentkey);

                if (appPromotion_value === currentDay) {
                    return true;
                } else {
                    return false;
                }

            }

            if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                var date = new Date();
                var userid = sessionStorage.getItem("x-uid");
                var startTime = new Date(sysParamCfg.appPromotion.startTime).getTime();
                var endTime = new Date(sysParamCfg.appPromotion.endTime).getTime();
                var currentTime = new Date().getTime();
                var currentDay = "" + date.getFullYear() + (date.getMonth() + 1) + date.getDate();
                var currentkey = userid + ":" + sysParamCfg.appPromotion.localStorageCurrentkey;
                var afterkey = userid + ":" + sysParamCfg.appPromotion.localStorageAfterkey;
                var appPromotionUrl = sysParamCfg.appPromotion.activityPage_url;

                if (sysParamCfg.appPromotion.switch && startTime < currentTime && currentTime < endTime && !checkDay()) {
                    ngDialog.open({
                        template: 'pages/common/dialog.appPromotion.html',
                        className: '',
                        controller: ['$scope', function ($scopeDlg) {
                            $scopeDlg.close = function () {
                                ngDialog.close();
                                localStorage.setItem(currentkey, currentDay);
                            };
                            $scopeDlg.confirm = function () {
                                setTimeout(function () {
                                    AUI.BaseJSUtil.redirectUrlByBlank(appPromotionUrl);
                                }, 500)
                            };
                        }]
                    });
                }
                if (sysParamCfg.appPromotion.afterSwitch && currentTime > endTime && !localStorage.getItem(afterkey) && !localStorage.getItem(currentkey)) {
                    ngDialog.open({
                        template: 'pages/common/dialog.appPromotion.html?v=20190213',
                        className: '',
                        controller: ['$scope', function ($scopeDlg) {
                            $scopeDlg.close = function () {
                                ngDialog.close();
                                localStorage.setItem(afterkey, true);
                            };
                            $scopeDlg.confirm = function () {
                                setTimeout(function () {
                                    AUI.BaseJSUtil.redirectUrlByBlank(appPromotionUrl);
                                }, 500)
                            };
                            $scopeDlg.isAfterAppPromotion = true;

                        }]
                    });
                }
            }
        }


        return {
            remindToUpdateUserInfo: remindToUpdateUserInfo,
            appPromotionService: appPromotionService
        }
    }]);
});

